import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import type { AiChatbotCmsPromptDto } from "../../../api/features/ai-chatbot-cms-prompt/dto/ai-chatbot-cms-prompt.dto";
import { AiChatbotCmsPrompt, AiChatbotCmsPromptInputAttributes } from "../types/ai-chatbot-cms-prompt.entity";

export function mapAiChatbotCmsPrompts(dtos: AiChatbotCmsPromptDto[]): AiChatbotCmsPrompt[] {
  return dtos.reduce((entities: AiChatbotCmsPrompt[], dto: AiChatbotCmsPromptDto) => {
    const rawPromptMessage = dto?.promptInput?.promptMessage;
    const isValidPromptMessage = !isEmpty(rawPromptMessage) && isString(rawPromptMessage);

    const rawDisplayText = dto?.promptInput?.displayText;
    const isValidDisplayText = !isEmpty(rawDisplayText) && isString(rawDisplayText);

    if (!isValidPromptMessage || !isValidDisplayText) {
      return entities;
    }

    const entity = new AiChatbotCmsPrompt();
    entity.active = dto.active;
    entity.priority = dto.priority;
    entity.showIn = dto.showIn;

    const aiPromptInput = new AiChatbotCmsPromptInputAttributes();
    aiPromptInput.promptMessage = rawPromptMessage;
    aiPromptInput.displayText = rawDisplayText;

    entity.aiPromptInput = aiPromptInput;
    entity.aiPromptPath = dto?.promptPath?.path ?? null;
    entity.defaultErrorResponse = dto.defaultErrorResponse;

    entities.push(entity);

    return entities;
  }, []);
}
